import React, { useEffect, useState } from 'react'
import { Result, Skeleton } from 'antd';
import { useHistory } from 'react-router-dom';
//Hooks
import { useFetch } from './../../Utils/Hooks/useFetch'
import { useTranslation } from 'react-i18next'

export default function Error()
{       
    const history = useHistory();
    const { t } = useTranslation(['login'])
    let errorId = new URLSearchParams(window.location.search).get("errorId")

    const [doFetch] = useFetch();
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState({})

    useEffect(() => {
        doFetch("/Error?errorId=" + errorId)
            .then((response) => onErrorFetchLoaded(response.isSuccess, response.result))
     
        function onErrorFetchLoaded(isSuccess, result) {
            processResponse(isSuccess, result)
            setIsLoading(false)
        }
    }, // eslint-disable-next-line 
    [])


    useEffect(() => {
        const currentReturnUrl = new URLSearchParams(window.location.search).get("errorId")

         if(currentReturnUrl !== null)
         {
            history.replace("/error")
         }
    }, // eslint-disable-next-line 
    [])

    if(isLoading)
    {
        return (
            <Skeleton title={false} paragraph={{rows:1}}/>
        )
    }

    return (
        <Result
            status={error.status}
            title={error.id}
            subTitle={error.message}
        />
    )

    function processResponse(isSuccess, result)
    {
        isSuccess ? setError({
            id: result.error,
            message:  t("error.defaultErrorDescription") + " Error code: " + result.errorDescription,
            status: 500
        }) : setError({
            id: getCorrectErrorId(result.message),
            message: t("error.defaultErrorDescription"),
            status: 500
        })
    }

    function getCorrectErrorId(id)
    {
        switch(id)
        {
            case "error.invalid_errorid":
            case "error.empty_errorid":
                return t("error.invalidErrorId")
            default:
                return  t("error.defaultErrorId")
        }
    }
}


